export default __webpack_public_path__ + "static/media/book-icon.a6715700.svg";